import React from "react";
import { Box, Button, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useNavigate } from "react-router-dom";

import GvPrimaryButton from "../../../../components/GvPrimaryButton/GvPrimaryButton";
import { PAGES_PATH } from "../../../../navigation/params";
import { CHECKOUT_COPY } from "../constants";

interface ICompletePurchaseErrorScreenProps {
  /** Omitted when there is nothing to retry (no id in the URL). */
  onRetry?: () => void;
}

// This route is authenticated-only, so the secondary action returns the user
// to the dashboard. TODO(SGPD-547): confirm with the designer — no error frame
// exists in Figma 35641:15508.
export const CompletePurchaseErrorScreen = ({ onRetry }: ICompletePurchaseErrorScreenProps) => {
  const navigate = useNavigate();

  return (
    <Box className="flex h-full min-h-[70vh] w-full flex-col items-center justify-center px-4 text-center">
      <ErrorOutlineIcon sx={{ fontSize: 56, color: "#E5484D" }} />
      <Typography variant="h4" sx={{ fontWeight: 600, mt: 2 }}>
        {CHECKOUT_COPY.ERROR_TITLE}
      </Typography>
      <Typography variant="body1" sx={{ mt: 1, color: "text.secondary" }}>
        {CHECKOUT_COPY.ERROR_SUBTITLE}
      </Typography>
      {onRetry && (
        <div className="mt-6 w-full max-w-xs">
          <GvPrimaryButton type="button" onClick={onRetry}>
            {CHECKOUT_COPY.ERROR_RETRY}
          </GvPrimaryButton>
        </div>
      )}
      <Button variant="text" sx={{ mt: 1 }} onClick={() => navigate(PAGES_PATH.DASHBOARD)}>
        {CHECKOUT_COPY.ERROR_GO_HOME}
      </Button>
    </Box>
  );
};

export default CompletePurchaseErrorScreen;
